import { render, staticRenderFns } from "./risktypeAdd.vue?vue&type=template&id=e2ab74dc"
import script from "./risktypeAdd.vue?vue&type=script&lang=js"
export * from "./risktypeAdd.vue?vue&type=script&lang=js"
import style0 from "./risktypeAdd.vue?vue&type=style&index=0&id=e2ab74dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports